import Resource from '@/plugins/sdk/Resource'
import { DATETIME, INTEGER, UUID, ITEM } from '@/plugins/sdk/fields'
import Zone from '@/plugins/sdk/resources/Dictionary/Zone'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Service from '@/plugins/sdk/resources/Carrier/Service'
import Location from '@/plugins/sdk/resources/Dictionary/Location'

export default class extends Resource {
  static name = 'etd'

  static get fields () {
    return {
      id: new UUID(),
      travel_days: new INTEGER(),
      delivery_date: new DATETIME(),
      zone_from: new ITEM(Zone),
      zone_to: new ITEM(Zone),
      location_from: new ITEM(Location),
      location_to: new ITEM(Location),
      carrier: new ITEM(Carrier),
      carrier_service: new ITEM(Service)
    }
  }
}
